/**
 * PomodoroWidget - Pomodoro timer as a dashboard widget
 */

import React from 'react';
import { WidgetWrapper } from './WidgetWrapper';
import { PomodoroTimer } from '../PomodoroTimer';
import type { PomodoroWidgetConfig } from '../../types/widgets';

interface PomodoroWidgetProps {
  config: PomodoroWidgetConfig;
  widgetId: string;
  windowId: string;
}

export function PomodoroWidget({ config, widgetId, windowId }: PomodoroWidgetProps) {
  return (
    <WidgetWrapper
      title={config.title || 'Pomodoro'}
      widgetId={widgetId}
      windowId={windowId}
    >
      <div className="p-3 h-full flex items-center justify-center">
        <PomodoroTimer isCompact={false} />
      </div>
    </WidgetWrapper>
  );
}
